import type { ReactNode } from 'react';
import './social-auth.css';
import { SocialLogo } from './social-logo';

export interface SocialAuthShellProps {
  children: ReactNode;
  claim: string;
  description: string;
  footer?: ReactNode;
  highlights?: readonly string[];
  subtitle?: string;
  title: string;
  variant?: 'login' | 'register';
}

function HighlightCheckIcon() {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      focusable="false"
      height="20"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="20"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

export function SocialAuthShell({
  children,
  claim,
  description,
  footer,
  highlights = [],
  subtitle,
  title,
  variant = 'login',
}: SocialAuthShellProps) {
  const layoutClassName = variant === 'register'
    ? 'or-social-auth or-social-auth--register'
    : 'or-social-auth';

  return (
    <div className={layoutClassName}>
      <aside aria-hidden="true" className="or-social-auth__visual">
        <SocialLogo className="or-social-auth__logo" />
        <h2 className="or-social-auth__claim">{claim}</h2>
        <p className="or-social-auth__subclaim">{description}</p>
        {highlights.length > 0 ? (
          <ul className="or-social-auth__highlights">
            {highlights.map((highlight) => (
              <li className="or-social-auth-highlight" key={highlight}>
                <span className="or-social-auth-highlight__icon"><HighlightCheckIcon /></span>
                <span className="or-social-auth-highlight__text">{highlight}</span>
              </li>
            ))}
          </ul>
        ) : null}
      </aside>
      <main className="or-social-auth__form-side">
        <div className="or-social-auth-card">
          {title || subtitle ? (
            <header className="or-social-auth-card__header">
              {title ? <h1 className="or-social-auth-card__title">{title}</h1> : null}
              {subtitle ? <p className="or-social-auth-card__subtitle">{subtitle}</p> : null}
            </header>
          ) : null}
          {children}
          {footer ? <footer className="or-social-auth-card__footer">{footer}</footer> : null}
        </div>
      </main>
    </div>
  );
}
